export default {
  pagination: {
    links: {
      next: '',
      previous: ''
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/pagination.js